import "../Styling/LanguageSelector.css"

export default function LanguageSelector({ changeLanguage, language }) {
    return (
        <div className="language-container">
            <div className="language-selector">
                <select value={language} onChange={(e) => changeLanguage(e.target.value)}>
                    <option value="sr">SR</option>
                    <option value="en">EN</option>
                    <option value="de">DE</option>
                </select>

            </div>
        </div>
    )
}